import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'funcionalidade-item',
  templateUrl: './funcionalidade-item.component.html',
  styleUrls: ['./funcionalidade-item.component.scss']
})
export class FuncionalidadeItemComponent implements OnInit {

  @Input("data") data               = null;
  @Input("classCustom") classCustom = "";

  constructor() { }  

  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit():void{}

}
